"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1768],{

/***/ 63064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PlayerThumbnail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_common_DirectusImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52520);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  object-fit: cover;\n  object-position: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Thumbnail = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(src_components_common_DirectusImage__WEBPACK_IMPORTED_MODULE_3__/* .DirectusImage */ .q).withConfig({
    displayName: "PlayerThumbnail__Thumbnail",
    componentId: "sc-464c59f1-0"
})(_templateObject());
var PlayerThumbnail = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function PlayerThumbnail(param) {
    var video = param.video;
    if (video.thumbnail == null) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Thumbnail, {
        src: video.thumbnail.id,
        layout: "fill",
        sizes: "90vw"
    });
});


/***/ }),

/***/ 41768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WistiaPlayerStrategy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/player/common.tsx
var common = __webpack_require__(33578);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./src/components/player/playerStrategy/WistiaPlayerStrategy/WistiaOverlay.ts

var extensionHandle = "neauviaOverlay";
var WistiaOverlay = /*#__PURE__*/ function() {
    "use strict";
    function WistiaOverlay(player) {
        (0,_class_call_check/* default */.Z)(this, WistiaOverlay);
        this.player = player;
        this.node = null;
    }
    var _proto = WistiaOverlay.prototype;
    _proto.mount = function mount(parent) {
        var node = document.createElement("div");
        this.node = node;
        parent.appendChild(node);
        node.dispatchEvent(new CustomEvent("wistiaOverlayReady", {
            bubbles: true,
            detail: {
                node: node
            }
        }));
    };
    _proto.destroy = function destroy() {
        var ref;
        (ref = this.node) === null || ref === void 0 ? void 0 : ref.remove();
    };
    return WistiaOverlay;
}();
WistiaOverlay.type = "foreground";
WistiaOverlay.handle = extensionHandle;
WistiaOverlay.sortValue = 500;
var attachWistiaOverlay = function() {
    if (Wistia._controlDefinitions[extensionHandle] != null) {
        return;
    }
    Wistia.defineControl(WistiaOverlay);
};

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(34156);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
;// CONCATENATED MODULE: ./src/components/player/playerStrategy/WistiaPlayerStrategy/wistiaConfigProviderFactory.ts



var wistiaConfigProviderFactory = function() {
    return memoizee_default()(function(controls, volume, loop, playing, muted, playFrom, opts) {
        var options = (0,_object_spread/* default */.Z)({
            playsinline: true,
            seo: false,
            preload: "none",
            playPauseNotifier: true,
            playbackRateControl: false,
            fakeFullscreen: true,
            copyLinkAndThumbnailEnabled: false,
            controlsVisibleOnLoad: false,
            fullscreenOnRotateToLandscape: true,
            playSuspendedOffScreen: true,
            playButton: true,
            googleAnalytics: false,
            resumable: false,
            transition: "fade",
            fullscreenButton: controls,
            playbar: controls,
            qualityControl: controls,
            volumeControl: controls,
            settingsControl: controls,
            smallPlayButton: controls,
            endVideoBehavior: loop ? "loop" : "default",
            silentAutoPlay: "allow",
            volume: volume,
            autoPlay: playing,
            muted: muted,
            time: !loop && (playFrom !== null && playFrom !== void 0 ? playFrom : 0) > 0 ? "".concat(playFrom) : undefined
        }, opts);
        return [
            options,
            (0,query_string.stringify)(options).replace(/&/g, " ")
        ];
    });
};

// EXTERNAL MODULE: ./node_modules/rambda/dist/rambda.esm.js
var rambda_esm = __webpack_require__(49713);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(25849);
;// CONCATENATED MODULE: ./src/components/player/playerStrategy/WistiaPlayerStrategy/unmuteWistia.ts

function unmuteWistia(wistiaPlayer) {
    var tryToUnmuteThisCrap = function tryToUnmuteThisCrap() {
        wistiaPlayer.unmute();
        var volume = wistiaPlayer.volume();
        if (volume === 0) {
            var userPreferences = storage/* localStorage.getItem */.X.getItem("wistia-viewer-preferences");
            var ref;
            wistiaPlayer.volume((ref = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.volume) !== null && ref !== void 0 ? ref : 1);
        }
    };
    return new Promise(function(resolve) {
        tryToUnmuteThisCrap();
        setTimeout(function() {
            tryToUnmuteThisCrap();
            resolve();
        }, 10);
    });
}

// EXTERNAL MODULE: ./node_modules/@summer/jst-functions/lib/index.js
var lib = __webpack_require__(42002);
// EXTERNAL MODULE: ./src/components/player/PlayerThumbnail.tsx
var PlayerThumbnail = __webpack_require__(63064);
;// CONCATENATED MODULE: ./src/components/player/playerStrategy/WistiaPlayerStrategy/index.tsx







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      overflow: hidden;\n\n      & > * {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        width: 100% !important;\n        height: 100% !important;\n      }\n\n      .w-chrome,\n      .w-chrome [id$='main'],\n      .w-chrome [id$='wrapper'] {\n        width: 100% !important;\n        height: 100% !important;\n        overflow: visible !important;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: transparent;\n\n      [data-handle='thumbnail'] {\n        display: none !important;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .w-chrome {\n        pointer-events: none;\n      }\n\n      .w-vulcan-overlays-table > * {\n        pointer-events: all;\n\n        &:hover,\n        &:focus {\n          .w-bottom-bar-right {\n            opacity: 1 !important;\n          }\n        }\n      }\n\n      div[data-handle='playPauseLoading'] {\n        display: none !important;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  .w-video-wrapper {\n    background: none !important;\n  }\n\n  .w-big-play-button {\n    & > div {\n      display: none !important;\n    }\n    & > svg {\n      filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 1)) !important;\n    }\n  }\n\n  .w-context-menu-anchor {\n    display: none !important;\n  }\n\n  .w-bottom-bar {\n    z-index: 10;\n  }\n\n  [data-handle='clickForSoundButton'] {\n    display: none !important;\n  }\n\n  ",
        ";\n\n  /* \n    Following operations on pointer-events are required to block pausing TV player. \n    We found no other way to disable pausing it. We need to re-enable pointer-events for controls. \n  */\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var WistiaContainer = (0,styled_components_browser_esm["default"])(common/* PlayerContainer */.AX).withConfig({
    displayName: "WistiaPlayerStrategy__WistiaContainer",
    componentId: "sc-bc0581a6-0"
})(_templateObject3(), (0,lib.casePath)("$fullscreen")(function() {
    return "";
}, function() {
    return (0,styled_components_browser_esm.css)(_templateObject());
}), (0,lib.casePath)("$customThumbnail")(function() {
    return (0,styled_components_browser_esm.css)(_templateObject1());
}, function() {
    return "";
}), (0,lib.casePath)("$blockPause")(function() {
    return (0,styled_components_browser_esm.css)(_templateObject2());
}, function() {
    return "";
}));
var WistiaPlayerStrategy = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(WistiaPlayerStrategy, PureComponent);
    var _super = (0,_create_super/* default */.Z)(WistiaPlayerStrategy);
    function WistiaPlayerStrategy(props) {
        (0,_class_call_check/* default */.Z)(this, WistiaPlayerStrategy);
        var _this;
        var ref;
        _this = _super.call(this, props);
        _this.state = {};
        _this.id = (0,v4/* default */.Z)();
        _this.wistiaConfigProvider = wistiaConfigProviderFactory();
        _this.containerRef = /*#__PURE__*/ (0,react.createRef)();
        _this._isMounted = true;
        // -- HANDLERS START
        _this.onReady = function(player) {
            var ref, ref1, ref2, _props, ref3;
            if (!_this._isMounted) {
                player.remove();
                return;
            }
            _this.player = player;
            _this.unbindPlayer();
            _this.bindPlayer();
            if (_this.props.volume != null && player.volume() !== _this.props.volume) {
                player.volume(_this.props.volume);
            }
            if (_this.props.muted === false && _this.player.isMuted()) {
                unmuteWistia(player);
            }
            if (_this.props.muted === true && !_this.player.isMuted()) {
                player.mute();
            }
            if (_this.props.playFrom != null && ((ref = _this.player) === null || ref === void 0 ? void 0 : ref.time()) !== _this.props.playFrom) {
                player.time(_this.props.playFrom);
            }
            if (_this.props.playing && ((ref1 = _this.player) === null || ref1 === void 0 ? void 0 : ref1.state()) !== "playing") {
                var ref4;
                (ref4 = _this.player) === null || ref4 === void 0 ? void 0 : ref4.play();
            } else if (!_this.props.playing && ((ref2 = _this.player) === null || ref2 === void 0 ? void 0 : ref2.state()) !== "paused") {
                var ref5;
                (ref5 = _this.player) === null || ref5 === void 0 ? void 0 : ref5.pause();
            }
            (ref3 = (_props = _this.props).onReady) === null || ref3 === void 0 ? void 0 : ref3.call(_props);
        };
        _this.onPlay = function() {
            var _props, ref;
            return (ref = (_props = _this.props).onPlay) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onPause = function() {
            var _props, ref;
            return (ref = (_props = _this.props).onPause) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onSeek = function(currentTime) {
            var _props, ref;
            return (ref = (_props = _this.props).onSeek) === null || ref === void 0 ? void 0 : ref.call(_props, currentTime);
        };
        _this.onVolumeChange = function(volume) {
            var _props, ref;
            return (ref = (_props = _this.props).onVolumeChange) === null || ref === void 0 ? void 0 : ref.call(_props, volume);
        };
        _this.onMuteChange = function(isMuted) {
            var _props, ref, _props1, ref1;
            return isMuted ? (ref = (_props = _this.props).onMute) === null || ref === void 0 ? void 0 : ref.call(_props) : (ref1 = (_props1 = _this.props).onUnmute) === null || ref1 === void 0 ? void 0 : ref1.call(_props1);
        };
        _this.onEnded = function() {
            var _props, ref;
            return (ref = (_props = _this.props).onEnded) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onEnterFullscreen = function() {
            var _props, ref;
            return (ref = (_props = _this.props).onEnterFullscreen) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onExitFullscreen = function() {
            var _props, ref;
            return (ref = (_props = _this.props).onLeaveFullscreen) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onOverlayReady = function(param) {
            var node = param.detail.node;
            return _this.setState({
                overlayNode: node
            });
        };
        (ref = props.innerRef) === null || ref === void 0 ? void 0 : ref.call(props, (0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = WistiaPlayerStrategy.prototype;
    _proto.getCurrentTime = function getCurrentTime() {
        var ref;
        var ref1;
        return (ref1 = (ref = this.player) === null || ref === void 0 ? void 0 : ref.time()) !== null && ref1 !== void 0 ? ref1 : 0;
    };
    _proto.getRealTime = function getRealTime() {
        return this.getCurrentTime();
    };
    _proto.enterFullscreen = function enterFullscreen() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                (ref = _this.player) === null || ref === void 0 ? void 0 : ref.requestFullscreen();
                return [
                    2
                ];
            });
        })();
    };
    _proto.exitFullscreen = function exitFullscreen() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                (ref = _this.player) === null || ref === void 0 ? void 0 : ref.cancelFullscreen();
                return [
                    2
                ];
            });
        })();
    };
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            mounted: true
        });
        this.bindContainer();
        this.initConfig = {
            id: this.id,
            onReady: this.onReady,
            onHasData: attachWistiaOverlay
        };
        window._wq = window._wq || [];
        window._wq.push(this.initConfig);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var ref, ref1;
        this.unbindContainer();
        this.bindContainer();
        if (prevProps.muted !== this.props.muted && this.player != null) {
            if (this.props.muted && !this.player.isMuted()) {
                this.player.mute();
            } else if (!this.props.muted && this.player.isMuted()) {
                unmuteWistia(this.player);
            }
        }
        if (prevProps.volume !== this.props.volume && this.props.volume != null) {
            var ref2;
            if (((ref2 = this.player) === null || ref2 === void 0 ? void 0 : ref2.volume()) !== this.props.volume) {
                var ref3;
                (ref3 = this.player) === null || ref3 === void 0 ? void 0 : ref3.volume(this.props.volume);
            }
        }
        if (prevProps.playFrom !== this.props.playFrom && this.props.playFrom != null) {
            var ref4;
            if (((ref4 = this.player) === null || ref4 === void 0 ? void 0 : ref4.time()) !== this.props.playFrom) {
                var ref5;
                (ref5 = this.player) === null || ref5 === void 0 ? void 0 : ref5.time(this.props.playFrom);
            }
        }
        if (prevProps.playing !== this.props.playing) {
            var ref6, ref7;
            if (this.props.playing && ((ref6 = this.player) === null || ref6 === void 0 ? void 0 : ref6.state()) !== "playing") {
                var ref8;
                (ref8 = this.player) === null || ref8 === void 0 ? void 0 : ref8.play();
            } else if (!this.props.playing && ((ref7 = this.player) === null || ref7 === void 0 ? void 0 : ref7.state()) !== "paused") {
                var ref9;
                (ref9 = this.player) === null || ref9 === void 0 ? void 0 : ref9.pause();
            }
        }
        if (((ref = prevProps.video.source) === null || ref === void 0 ? void 0 : ref.url) !== ((ref1 = this.props.video.source) === null || ref1 === void 0 ? void 0 : ref1.url)) {
            var ref10;
            (ref10 = this.player) === null || ref10 === void 0 ? void 0 : ref10.replaceWith(this.getWistiaId(), this.getWistiaOptions()[0]);
        }
        if (prevProps.fullscreen !== this.props.fullscreen && this.player != null) {
            if (!this.props.fullscreen && this.player.inFullscreen()) {
                this.exitFullscreen();
            }
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var ref;
        this._isMounted = false;
        this.exitFullscreen();
        this.unbindPlayer();
        this.unbindContainer();
        (ref = this.player) === null || ref === void 0 ? void 0 : ref.remove();
        window._wq = window._wq || [];
        window._wq.push({
            revoke: this.initConfig
        });
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, video = _props.video, playedOnce = _props.playedOnce, fullscreen = _props.fullscreen, wistiaOptions = _props.wistiaOptions, controls = _props.controls;
        var _state = this.state, overlayNode = _state.overlayNode, mounted = _state.mounted;
        var videoId = this.getWistiaId();
        var className = "wistia_embed wistia_async_".concat(videoId, " ").concat(this.getWistiaOptions()[1]);
        return mounted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !playedOnce && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerThumbnail/* PlayerThumbnail */.z, {
                    video: video
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaContainer, {
                    "data-keep-focus": true,
                    ref: this.containerRef,
                    id: this.id,
                    className: className,
                    $fullscreen: fullscreen === true,
                    $blockPause: controls === false || (wistiaOptions === null || wistiaOptions === void 0 ? void 0 : wistiaOptions.playbar) === false && (wistiaOptions === null || wistiaOptions === void 0 ? void 0 : wistiaOptions.playButton) === false && (wistiaOptions === null || wistiaOptions === void 0 ? void 0 : wistiaOptions.smallPlayButton) === false,
                    $customThumbnail: !playedOnce
                }),
                fullscreen && overlayNode != null ? /*#__PURE__*/ react_dom.createPortal(children, overlayNode) : children
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    _proto.getWistiaId = function getWistiaId() {
        var ref;
        var ref1;
        return (0,rambda_esm.last)((ref1 = (ref = this.props.video.source) === null || ref === void 0 ? void 0 : ref.url.split(/\//)) !== null && ref1 !== void 0 ? ref1 : []);
    };
    _proto.getWistiaOptions = function getWistiaOptions() {
        var _controls;
        return this.wistiaConfigProvider((_controls = this.props.controls) !== null && _controls !== void 0 ? _controls : true, this.props.volume, this.props.loop, this.props.playing, this.props.muted, this.props.playFrom, this.props.wistiaOptions);
    };
    _proto.bindPlayer = function bindPlayer() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        (ref = this.player) === null || ref === void 0 ? void 0 : ref.bind("play", this.onPlay);
        (ref1 = this.player) === null || ref1 === void 0 ? void 0 : ref1.bind("pause", this.onPause);
        (ref2 = this.player) === null || ref2 === void 0 ? void 0 : ref2.bind("seek", this.onSeek);
        (ref3 = this.player) === null || ref3 === void 0 ? void 0 : ref3.bind("volumechange", this.onVolumeChange);
        (ref4 = this.player) === null || ref4 === void 0 ? void 0 : ref4.bind("mutechange", this.onMuteChange);
        (ref5 = this.player) === null || ref5 === void 0 ? void 0 : ref5.bind("end", this.onEnded);
        (ref6 = this.player) === null || ref6 === void 0 ? void 0 : ref6.bind("enterfullscreen", this.onEnterFullscreen);
        (ref7 = this.player) === null || ref7 === void 0 ? void 0 : ref7.bind("cancelfullscreen", this.onExitFullscreen);
    };
    _proto.unbindPlayer = function unbindPlayer() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        (ref = this.player) === null || ref === void 0 ? void 0 : ref.unbind("play", this.onPlay);
        (ref1 = this.player) === null || ref1 === void 0 ? void 0 : ref1.unbind("pause", this.onPause);
        (ref2 = this.player) === null || ref2 === void 0 ? void 0 : ref2.unbind("seek", this.onSeek);
        (ref3 = this.player) === null || ref3 === void 0 ? void 0 : ref3.unbind("volumechange", this.onVolumeChange);
        (ref4 = this.player) === null || ref4 === void 0 ? void 0 : ref4.unbind("mutechange", this.onMuteChange);
        (ref5 = this.player) === null || ref5 === void 0 ? void 0 : ref5.unbind("end", this.onEnded);
        (ref6 = this.player) === null || ref6 === void 0 ? void 0 : ref6.unbind("enterfullscreen", this.onEnterFullscreen);
        (ref7 = this.player) === null || ref7 === void 0 ? void 0 : ref7.unbind("cancelfullscreen", this.onExitFullscreen);
    };
    _proto.bindContainer = function bindContainer() {
        var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ref;
        (ref = this.containerRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("wistiaOverlayReady", this.onOverlayReady);
    };
    _proto.unbindContainer = function unbindContainer() {
        var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ref;
        (ref = this.containerRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("wistiaOverlayReady", this.onOverlayReady);
    };
    return WistiaPlayerStrategy;
}(react.PureComponent);



/***/ })

}]);